import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=6565da04"
import script from "./EventList.js?vue&type=script&lang=js&external"
export * from "./EventList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports